"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['pageType'],
  data: function data() {
    return {
      type: '',
      id: '',
      dialogVisible: false,
      popTitle: '',
      ruleForm: {
        title: ''
      },
      rules: {
        title: [{
          required: true,
          message: '请输入模板名称',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    open: function open(data) {
      var _this = this;
      this.dialogVisible = true;
      console.log(data);
      this.popTitle = data.title;
      this.type = data.type;
      if (data.type === 'upDate') {
        setTimeout(function () {
          _this.id = data.id;
          _this.ruleForm.title = data.name;
        }, 200);
      }
    },
    onClose: function onClose() {
      this.ruleForm = {
        title: ''
      };
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var obj = {};
          if (_this2.type === 'add') {
            obj = {
              name: _this2.ruleForm.title,
              type: _this2.$props.pageType
            };
          } else {
            obj = {
              name: _this2.ruleForm.title,
              type: _this2.$props.pageType,
              pageId: _this2.id
            };
          }
          (0, _customPage.saveOrUpdate)(obj).then(function (res) {
            if (res.data) {
              _this2.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this2.$emit('refresh', _this2.type);
              _this2.onClose();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};